import { ROUTE_PREFIX } from '@core/config/constants.js'
import constants from '@core/config/constants'
import {loadMarketingSplitFile} from '@core/config/utils'
let checkSPlitKey;
loadMarketingSplitFile().then(res=>{
  checkSPlitKey = res.checkSPlitKey
},err=>{
  checkSPlitKey = () => false
})


export default [
  {
    path: `${ROUTE_PREFIX}/:accountId/users-&-permissions`,
    name: "create-update-user",
    component: () => import("@core/views/user/Index.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: `${ROUTE_PREFIX}/app-denied`,
    name: "AppDenied",
    meta: { requiresAuth: false },
    component: () => import("@core/views/MAppDenied.vue"),
  },
  {
    path: `/404`,
    name: "Error_404",
    meta: { requiresAuth: false },
    component: () => import("@core/views/MError404.vue"),
  },
  {
    path: `${ROUTE_PREFIX}/:accountId/contacts/:contactId`,
    name: "contact-dashboard",
    component: async() => {
      if (process.env.VUE_APP_PRODUCT == 'Service') {
       return import("@core/views/contacts/service/Init.vue")
      } else {
        if(await checkSPlitKey(constants.SPLIT_IO_KEYS.isUIDAccount))
          return import("@core/views/contacts/marketing/UIDInit.vue")
        else
        return import("@core/views/contacts/marketing/Init.vue")
      }
    },
    meta: { requiresAuth: true },
  },
  {
    path: "/accounts/:accountId/lists/:listId/contacts/:contactId",
    name: "contact-dashboard-list-view",
    meta: { requiresAuth: true, childRouteWithinFolder: "list" },
    component:  async() => await checkSPlitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import('@core/views/contacts/marketing/UIDInit.vue') : import('@core/views/contacts/marketing/Init.vue')
  },
  {
    path: `${ROUTE_PREFIX}/:accountId/account-&-billing`,
    meta: { requiresAuth: true },
    component: () => import("@core/views/self_service/Init.vue"),
      children: [
        {
          path: "",
          name: "Account_settings_overview",
          meta: { requiresAuth: true },
          component: () => import("@core/views/self_service/AccountOverview.vue"),
        },
        {
          path: "company-information",
          name: "Account_settings_account",
          meta: { requiresAuth: true },
          component: () => import("@core/views/self_service/AccountSettings.vue"),
        },
        {
          path: "usage",
          name: "Account_usage",
          meta: { requiresAuth: true },
          component: () => import("@core/views/self_service/usage"),
        },
        {
          path: "subscriptions",
          name: "Account_subscription",
          meta: { requiresAuth: true },
          component: () => import("@core/views/self_service/Subscription"),
        },
        {
          path: "requests",
          name: "Account_subscription_requests",
          meta: { requiresAuth: true },
          component: () => import("@core/views/self_service/Requests"),
        },
      ]
  },
  {
    path: `${ROUTE_PREFIX}/:accountId/contacts/:contactId/orders`,
    name: "contact-orders",
    meta: { requiresAuth: true },
    component: () => import("@core/views/contacts/Orders.vue")
  },
  {
    path: "/accounts/:accountId/lists/:listId/contacts/:contactId/orders",
    name: "list-contact-orders",
    meta: { requiresAuth: true },
    component: () => import("@core/views/contacts/Orders.vue")
  },
  /**
   * commenting this route to test timezone functionality
   */
  // {
  //   path: "/accounts/:accountId/notifications",
  //   name: "Notifications",
  //   meta: { requiresAuth: true },
  //   component: () => import("@core/views/Notifications.vue")
  // },
  {
    path: "/access-denied",
    name: "Access_denied",
    meta: { requiresAuth: false },
    component: () => import("@core/views/MAccessDenied.vue")
  }
]
